import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldDateComponent } from './field-date.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";



@NgModule({
  declarations: [
    FieldDateComponent
  ],
  exports: [
    FieldDateComponent
  ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule
    ]
})
export class FieldDateModule { }
